import React, { SVGProps, useContext } from 'react';
import { ThemeContext } from 'styled-components';

interface NewInfoIconProps extends SVGProps<SVGSVGElement> {
  /** Color of the outer circle. Defaults to the theme primary so existing usages are unchanged.
   *  Pass "currentColor" to inherit the surrounding text color. */
  circleFill?: string;
}

const NewInfoIcon = ({ circleFill, ...props }: NewInfoIconProps) => {
  const theme = useContext(ThemeContext);
  return (
    <svg height="14" width="14" fill="none" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7 -6.11959e-07C3.13401 -9.49935e-07 9.49935e-07 3.13401 6.11959e-07 7C2.73984e-07 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 -2.73984e-07 7 -6.11959e-07Z"
        fill={circleFill ?? theme.colors.primary.c500}
        fillRule="evenodd"
      />
      <path
        d="M7 3C7.55228 3 8 3.44772 8 4C8 4.55228 7.55228 5 7 5L6.99167 5C6.43938 5 5.99167 4.55228 5.99167 4C5.99167 3.44772 6.43938 3 6.99167 3L7 3ZM6 7C6 6.44772 6.44772 6 7 6C7.55228 6 8 6.44772 8 7L8 10C8 10.5523 7.55228 11 7 11C6.44771 11 6 10.5523 6 10L6 7Z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default NewInfoIcon;
